import axios from "axios";
import config from "config.json";
import { message } from "antd";

axios.interceptors.response.use(null, error => {
  if (
    error.response &&
    (error.response.status === 403 || error.response.status === 421)
  ) {
    message.error(error.response.data.message);
    localStorage.setItem(config.JWT_TOKEN, null);
    window.location = "/";
  }

  return Promise.reject(error);
});

export function setAccessHeader(jwt) {
  if (jwt !== null && jwt !== "") {
    axios.defaults.headers.common["x-user-auth"] = jwt;
  } else {
    axios.defaults.headers.common = {};
  }
}

export function getBaseUrl() {
  const baseUrl = localStorage.getItem(config.BASE_URL);

  if (baseUrl == null || baseUrl == "") {
    window.location = "/";
  }
  return baseUrl;
  //return "http://localhost:8080/api";
}

export default {
  get: axios.get,
  post: axios.post,
  delete: axios.delete,
  put: axios.put,
  setAccessHeader,
  getBaseUrl
};
